import React, { useEffect, useState } from 'react'
import './about.css'

const About = () => {

    const [rating, setRating] = useState(null);

    useEffect(() => {
        fetch('https://codeforces.com/api/user.rating?handle=ErrorAssassin')
            .then((res) => res.json())
            .then((data) => {
                setRating(data.result[data.result.length - 1].newRating);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);

    console.log(rating);

    return (
        <div className="about-hero">
            <div className="page-title">
                About Me
            </div>
            <div className='about-container'>

                <div className="about-line">
                    <div className='emoji'>👋</div>
                    <div>I am <strong>Pulkit Agrawal</strong>, from Mumbai, India.</div>
                </div>
                <div className="about-line">
                    <div className='emoji'>🏫</div>
                    <div>An undergrad at <strong>IIT Delhi</strong> (one of the most prestigious engineering colleges in India.),<br />pursuing B.Tech in Mathematics and Computing.</div>
                </div>
                <div className="about-line">
                    <div className='emoji'>✨</div>
                    <div>Dedicated to open-source development, crafting visually appealing and user-friendly web pages for both desktop and mobile platforms</div>
                </div>
                <div className="about-line">
                    <div className='emoji'>💻</div>
                    <div>Also a Competitive Programmer, rated <strong>{rating}</strong> (live) on CodeForces!</div>
                </div>
                <div className="about-line">
                    <div className='emoji'>🌱</div>
                    <div>Engaged in continuous <strong>learning</strong>, exploring new technologies every day, and growing steadily.</div>
                </div>
            </div>
        </div>
    )
}

export default About